export const ApiUrl = {
  //CLIENT AUTH URL START HERE
  CLIENT_CREATE_LOGIN: "tenant/auth/session",
  CLIENT_FORGOT_PASSWORD: "tenant/auth/password/forgot",
  CLIENT_VERIFY_OTP: "tenant/auth/otp/verify",
  CLIENT_RESET_PASSWORD: "tenant/auth/password/reset",
  CLIENT_CHANGE_PASSWORD: "tenant/auth/password/change",

  CLIENT_USER_CHANGE_PASSWORD:"tenant/user/password",

  CLIENT_TENANT_POST: "tenant/user",
  CLIENT_USER_DATA_GET: "tenant/user",
  CLIENT_USER_DETAILS_DATA_GET: "tenant/user/view",
  CLIENT_ADV_POST: "tenant/advertisement",
  CLIENT_ADV_DATA_DELETE: "tenant/advertisement",
  CLIENT_ADV_DATA_GET: "tenant/advertisement",
  CLIENT_ADV_DETAILS_DATA_GET: "tenant/advertisement/view",
  CLIENT_BRANDING: "tenant/branding",
  CLIENT_PODCAST_DATA_GET: "tenant/podcast",
  CLIENT_PODCAST_DETAILS_DATA_GET: "tenant/podcast/view",
  CLIENT_PROFILE_DATA_GET: "tenant/auth/profile",
  CLIENT_SUBSCRIPTION_GET: "tenant/subscription",
  CLIENT_CMS_DATA_GET: "tenant/cms/view",
  CLIENT_TENANT_BULK_UPLOAD: "tenant/user/bulk",
  CLIENT_USER_ACTIVITY_GET: "tenant/user/activity",
  CLIENT_USER_CATEGORY_GET: "tenant/podcast/category",
  CLIENT_DASHBOARD_COUNT_GET: "tenant/dashboard/count",
  CLIENT_DASHBOARD_PIE_CHART_DATA_GET: "tenant/dashboard/user",
  CLIENT_PODCAST_LISTENERS_GET: "tenant/dashboard/date",
  CLIENT_PODCAST_CATEGORY_WISE_LISTENERS_GET: "tenant/dashboard/category",
  CLIENT_TOP_10_LISTENERS_GET: "tenant/dashboard/top-listener",
  CLIENT_TOP_100_MOST_LISTENED_GET: "tenant/dashboard/top-most-listened",
  CLIENT_TOP_100_LEAST_LISTENED_GET: "tenant/dashboard/top-least-listened",
  CLIENT_USER_ACTIVITY_DATA_GET: "tenant/activity",
};
